import { render } from "./RevocationWatchList.vue?vue&type=template&id=2a5233fa&scoped=true"
import script from "./RevocationWatchList.vue?vue&type=script&lang=js"
export * from "./RevocationWatchList.vue?vue&type=script&lang=js"

import "./RevocationWatchList.vue?vue&type=style&index=0&id=2a5233fa&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5233fa"]])

export default __exports__